const getStartPage = (permissions, isCustomer = false) => {
  if (permissions) {
    if (isCustomer) {
      return '/Customer/Invoices';
    }
    if (permissions.displayDashboard) {
      return '/Dashboard';
    } else if (permissions.virtualTerminal) {
      return '/Terminal';
    } else {
      return '/Invoices';
    }
  } else {
    return '/Login'; // If no permissions, redirect to login page
  }
};

export default getStartPage;
